import { ComponentPublicInstance, onUnmounted, Ref, computed, watch, ref } from 'vue';
import vClickOutside from 'v-click-outside';
const { bind, unbind } = vClickOutside.directive;

export function useClickOutside(
    elementRef: Ref<HTMLElement | ComponentPublicInstance | null | undefined>,
    callback: (event: MouseEvent) => void,
    defaultActive = true
) {
    const isRegistered = ref(false);
    const isActive = ref(defaultActive);

    const element = computed(() => {
        if (!elementRef.value) return;
        return '$el' in elementRef.value ? elementRef.value.$el : elementRef.value;
    });

    const destroyWatcher = (el?: Element) => {
        const htmlElement = el || element.value;

        if (!htmlElement) {
            isRegistered.value = false;
            return;
        }
        if (!isRegistered.value) return;

        unbind(htmlElement);
        isRegistered.value = false;
    };

    watch([element, isActive], ([el, active], [oldEl]) => {
        if (!active || !el) {
            destroyWatcher();
            return;
        }

        if (el != oldEl) {
            destroyWatcher(oldEl);
        }

        bind(el, { value: callback });
        isRegistered.value = true;
    });

    onUnmounted(destroyWatcher);

    return { clickOutsideActive: isActive };
}
